
import styled from 'styled-components';

export const ValidationContainer = styled.div`
.react-tel-input .form-control {
    width: 100%;
    background-color: #fff;
    height:45px;
    border: 1px solid #d9d9d9;
}

`